<template>
    <div class="min-h-full flex items-center justify-center mt-12">
        <div class="container-padded max-w-lg w-full space-y-8 shadow-md sm:p-12">
            <article>
                <header>
                    <h2 class="text-center mb-4">
                        <svg-vue icon="salesium-logo" class="w-8 inline-block mr-3"/>
                        Salesium
                    </h2>
                </header>

                <!--        <section :class="animation">
                          <p class="text-center text-base mb-5">
                            {{ formGroup[formPosition].title }}
                          </p>
                -->
                <ValidationObserver v-slot="{ invalid }" mode="aggressive" ref="observer">
                    <p class="text-center italic mb-3 mt-3">
                        You're protected, we never share your info.
                    </p>
                    <p class="text-center mt-3">
                        <a href="/login" class="bronze-link">Already have an account? Log in here</a>
                    </p>
                    <p class="text-center text-hint italic mb-5 mt-3">
                        <span class="text-red-500">*</span> indicates a required field
                    </p>
                    <form @submit.prevent="onSubmit" class="space-y-6">
      <span class="text-red-500 text-hint" v-for="(error, index) in validationErrors['invite_id']" :key="index">
        {{ error }}
        <a class="text-red-500" href="/register">Please click here to restart the registration process without an invite id.</a>
      </span>
                        <div class="grid grid-cols-6 gap-6">
                            <div class="col-span-6 sm:col-span-3">
                                <ValidationProvider rules="required" v-slot="{ classes, errors }">
                                    <div class="control is-required"
                                         :class="{...classes, 'is-server-invalid': validationErrors['firstName']}">
                                        <label for="firstName">First Name</label>
                                        <input
                                            id="firstName"
                                            name="firstName"
                                            type="text"
                                            autocomplete="given-name"
                                            class="input-field block w-full"
                                            required
                                            v-model="formData.firstName"
                                            @click="clearValidationErrors"
                                        />
                                        <span class="text-red-500 text-hint">{{ errors[0] }}</span>
                                        <span class="text-red-500 text-hint"
                                              v-for="(error, index) in validationErrors['firstName']"
                                              :key="index">{{ error }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>

                            <div class="col-span-6 sm:col-span-3">
                                <ValidationProvider rules="required" v-slot="{ classes, errors }">
                                    <div class="control is-required"
                                         :class="{...classes, 'is-server-invalid': validationErrors['lastName']}">
                                        <label for="lastName">Last Name</label>
                                        <input
                                            id="lastName"
                                            name="lastName"
                                            type="text"
                                            autocomplete="family-name"
                                            class="input-field block w-full"
                                            required
                                            v-model="formData.lastName"
                                            @click="clearValidationErrors"
                                        />
                                        <span class="text-red-500 text-hint">{{ errors[0] }}</span>
                                        <span class="text-red-500 text-hint"
                                              v-for="(error, index) in validationErrors['lastName']"
                                              :key="index">{{ error }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                        </div>

                        <div>
                            <ValidationProvider rules="required|email" v-slot="{ classes, errors }">
                                <div class="control is-required"
                                     :class="{...classes, 'is-server-invalid': validationErrors['email']}">
                                    <label for="email">Email</label>
                                    <input
                                        id="email-address"
                                        name="email"
                                        type="email"
                                        autocomplete="email"
                                        class="input-field w-full"
                                        required
                                        v-model="formData.email"
                                        @click="clearValidationErrors"
                                    />
                                    <span class="text-red-500 text-hint">{{ errors[0] }}</span>
                                    <span class="text-red-500 text-hint"
                                          v-for="(error, index) in validationErrors['email']" :key="index">{{
                                            error
                                        }}</span>
                                </div>
                            </ValidationProvider>
                        </div>

                        <div>
                            <ValidationProvider rules="phone" v-slot="{ classes, errors }">
                                <div class="control"
                                     :class="{...classes, 'is-server-invalid': validationErrors['phone']}">
                                    <label for="phone">Mobile Number</label>
                                    <input
                                        id="phone-number"
                                        name="phone"
                                        type="tel"
                                        autocomplete="tel"
                                        class="input-field block w-full"
                                        v-model="formData.phone"
                                        v-mask="'(###) ###-####'"
                                        @click="clearValidationErrors"
                                    />
                                    <span class="text-red-500 text-hint">{{ errors[0] }}</span>
                                    <span class="text-red-500 text-hint"
                                          v-for="(error, index) in validationErrors['phone']" :key="index">{{
                                            error
                                        }}</span>
                                </div>
                            </ValidationProvider>
                        </div>

                        <div>
                            <ValidationProvider rules="required" v-slot="{ classes, errors }">
                                <div class="control is-required"
                                     :class="{...classes, 'is-server-invalid': validationErrors['username']}">
                                    <label for="username">Username</label>
                                    <input
                                        id="username"
                                        name="username"
                                        type="text"
                                        autocomplete="username"
                                        class="input-field w-full"
                                        required
                                        v-model="formData.username"
                                        @click="clearValidationErrors"
                                    />
                                    <span class="text-red-500 text-hint">{{ errors[0] }}</span>
                                    <span class="text-red-500 text-hint"
                                          v-for="(error, index) in validationErrors['username']" :key="index">{{
                                            error
                                        }}</span>
                                </div>
                            </ValidationProvider>
                        </div>

                        <div>
                            <ValidationProvider
                                rules="required|min:8|password"
                                v-slot="{ classes, errors }"
                                vid="password"
                            >
                                <div class="control is-required"
                                     :class="{...classes, 'is-server-invalid': validationErrors['password']}">
                                    <div class="flex">
                                        <label for="password">Password</label>
                                        <form @submit.prevent="makeVisible">
                                            <button class="flex ml-2 mt-1" @click.prevent="makeVisible">
                                                <svg class=" flex h-5 w-5 text-red-500" width="16" height="16"
                                                     viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
                                                     fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                    <path stroke="none" d="M0 0h24v24H0z"/>
                                                    <circle cx="12" cy="12" r="2"/>
                                                    <path d="M2 12l1.5 2a11 11 0 0 0 17 0l1.5 -2"/>
                                                    <path d="M2 12l1.5 -2a11 11 0 0 1 17 0l1.5 2"/>
                                                </svg>
                                            </button>
                                        </form>
                                    </div>
                                    <input
                                        v-if="showPassword"
                                        id="password"
                                        name="password"
                                        type="text"
                                        autocomplete="current-password"
                                        class="input-field w-full"
                                        required
                                        v-model="formData.password"
                                        @click="clearValidationErrors"
                                    />
                                    <input
                                        v-else
                                        id="password"
                                        name="password"
                                        type="password"
                                        autocomplete="current-password"
                                        class="input-field w-full"
                                        required
                                        v-model="formData.password"
                                        @click="clearValidationErrors"
                                    />
                                    <span class="text-red-500 text-hint">{{ errors[0] }}</span>
                                    <span class="text-red-500 text-hint"
                                          v-for="(error, index) in validationErrors['password']" :key="index">{{
                                            error
                                        }}</span>
                                </div>
                            </ValidationProvider>
                        </div>

                        <div>
                            <ValidationProvider
                                rules="required|confirmed:password"
                                v-slot="{ classes, errors }"
                            >
                                <div class="control is-required" :class="classes">
                                    <label for="confirm-password">Confirm Password</label>
                                    <input
                                        v-if="showPassword"
                                        id="confirm-password"
                                        name="confirm-password"
                                        type="text"
                                        autocomplete="current-password"
                                        class="input-field w-full"
                                        required
                                        v-model="formData.confirm"
                                    />
                                    <input
                                        v-else
                                        id="confirm-password"
                                        name="confirm-password"
                                        type="password"
                                        autocomplete="current-password"
                                        class="input-field w-full"
                                        required
                                        v-model="formData.confirm"
                                    />
                                    <span class="text-red-500 text-hint">{{ errors[0] }}</span>
                                </div>
                            </ValidationProvider>
                        </div>

                        <div class="mb-3 space-y-4 mt-14">
                            <ValidationProvider rules="required">
                                <div class="rounded-md flex justify-start w-2/3">
                                    <div>I'm a</div>
                                    <div class="rounded-md">
                                        <input type="radio" v-model="formData.accountType"
                                               value="customer" id="Customer" name="type" style="visibility:hidden"/>
                                        <label for="Customer" class="radio text-center self-center py-2 px-4 rounded-md
                                         cursor-pointer hover:opacity-75 border-salesium-grey-100 border-2">Customer</label>
                                    </div>
                                    <div class="rounded-md">
                                        <input type="radio" v-model="formData.accountType"
                                               value="pro" id="Pro" name="type" style="visibility:hidden"/>
                                        <label for="Pro" class="radio text-center self-center py-2 px-4 rounded-md
                                         cursor-pointer hover:opacity-75 border-salesium-grey-100 border-2">Pro</label>
                                    </div>
                                </div>
                            </ValidationProvider>
                        </div>

                        <div class="mb-3 space-y-4 mt-14">
                            <ValidationProvider rules="required|digits:5" >
                                <div class="text-center space-y-4 control is-required">
                                    <label for="postal_code">Home Zip Code (5 digit)</label>
                                    <input
                                        id="postal_code"
                                        name="postal_code"
                                        type="text"
                                        placeholder="ddddd"
                                        autocomplete="postal_code"
                                        class="input-field w-full"
                                        required
                                        v-model="formData.homePostalCode"
                                    />
                                </div>
                            </ValidationProvider>
                            <ValidationProvider  rules="required|digits:5" >
                                <div v-if="formData.accountType === 'pro'" class="text-center space-y-4 control is-required">
                                    <label for="postal_code">Business Zip Code (5 digit)</label>
                                    <input
                                        id="postal_code"
                                        name="postal_code"
                                        type="text"
                                        placeholder="ddddd"
                                        autocomplete="postal_code"
                                        class="input-field w-full"
                                        required
                                        v-model="formData.businessPostalCode"
                                    />
                                </div>
                            </ValidationProvider>

                            <div class="text-center">
                                <button
                                    type="submit"
                                    class="primary-btn mt-14 px-12"
                                    :disabled="invalid"
                                >
                                    Join the Community
                                </button>
                            </div>
                        </div>

                        <div class="text-center">
                            By registering you are agreeing to our <a href="https://salesium.com/privacy-policy/"
                                                                      target="_blank" rel="noopener noreferrer">Privacy
                            Policy</a> and <a href="https://salesium.com/termsandconditions/" target="_blank"
                                              rel="noopener noreferrer">Terms of Service</a>.
                        </div>
                    </form>
                </ValidationObserver>
            </article>
        </div>
    </div>
</template>

<script>
import {stripPhoneMask} from "../../helpers/stripPhoneMask";
import {
    ValidationObserver,
    ValidationProvider,
} from "vee-validate";
import { VueMaskDirective } from "v-mask";
import Vue from "vue";

export default {
    props: ["invite_id", "user_id", "organization_id"],
    data() {
        return {
//      formPosition: 0,
//      animation: "animate-in",
            formData: {
                email: "",
                password: "",
                confirm: null,
                firstName: "",
                lastName: "",
                username: "",
                phone: null,
                accountType: "customer",
                businessPostalCode: "",
                homePostalCode: "",
            },
            validationErrors: {},
            showPassword: false,
//      formGroup: [
//        { title:
//            "Tell us a little about yourself" },
//        {
//          title:
//            "Are you a professional looking to meet customers, or a customer that wants to find a pro to help you?",
//        },
//        {
//          title:
//            "Help us put you on the map."
//        }
//      ],
        };
    },
    methods: {
//    nextStep() {
//      this.animation = "animate-out";
//      setTimeout(() => {
//        this.animation = "animate-in";
//        this.formPosition += 1;
//      }, 600);
//    },
//    handleNext(event) {
//      this.formData = { ...this.formData, ...event };
//      console.info(`handleNext:\n  data: ${JSON.stringify(this.data)}\n  formData: ${JSON.stringify(this.formData)}\n  event: ${JSON.stringify(event)}`);
//      this.nextStep();
//    },
        async onSubmit(accountType) {
            console.info(`accountType: ${accountType}\nonSubmit:\n   formData: ${JSON.stringify(this.formData)}\n  event: ${JSON.stringify(event)}`);
            const response = await window.axios.post('/api/register', {
                first_name: this.formData.firstName,
                last_name: this.formData.lastName,
                email: this.formData.email.toLowerCase(),
                username: this.formData.username.toLowerCase(),
                phone: this.formData.phone ? stripPhoneMask(this.formData.phone) : null,
                business_postal_code: this.formData.businessPostalCode,
                home_postal_code: this.formData.homePostalCode,
                password: this.formData.password,
                type: this.formData.accountType,
                ...(this.invite_id && {invite_id: this.invite_id}),
                ...(this.user_id && {user_id: this.user_id}),
                ...(this.organization_id && {organization_id: this.organization_id}),
            }).catch(err => {
                console.error('ERROR:', err.response.data.message);
                if (err.response.status === 422) {
                    this.validationErrors = err.response.data.errors;
                    this.formPosition = 0;
                }
            });

            console.log("account type " + this.formData.accountType);
            if (response) {
                let redirect = '/';

                if (this.formData.accountType === 'pro') {
//                    redirect = '/invite-contacts?to=home';
                    redirect = '/pro-registration-choice';
                }

//                Vue.toasted.success('Successfully signed up!',
//                    {duration: 5000, // milliseconds
//                            position: "top-center"});

                console.log("redirect " + redirect);
                window.location.href = redirect;            }
        },
        clearValidationErrors(event) {
            if (this.validationErrors[event.target.name]) {
                delete this.validationErrors[event.target.name]
            }
        },
        makeVisible() {
            this.showPassword = !this.showPassword;
        }
    },
    components: {
        ValidationProvider,
        ValidationObserver,
    },
    directives: {
        mask: VueMaskDirective,
    },
};
</script>

<!--<style scoped>
.animation-in {
  transform-origin: left;
  animation: in 0.6s ease-in-out;
}
.animation-out {
  transform-origin: bottom left;
  animation: out 0.6s ease-in-out;
}
</style>
-->
